import { Flex, spaceMixin } from '@zillow/constellation';
import styled from 'styled-components';

export const StyledUploadedAttachmentCards = styled(Flex)`
  max-height: 95px;
  overflow-y: auto;
  margin-left: -${spaceMixin('xs')};
  padding: 0 ${spaceMixin('xs')} ${spaceMixin('sm')} ${spaceMixin('xs')};
`;

export const StyledUploadedWrapper = styled.div`
  position: relative;
  margin-top: ${spaceMixin('xs')};
`;

export const StyledLinearGradient = styled.div`
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.0001) 24.14%, #fffdfd 80.78%);
  height: 15px;
  width: 100%;
  position: absolute;
  bottom: -1px;
  left: 0;
`;
